import { createAction } from "redux-actions";
import createAsyncActions from "../../../utilities/createAsyncActions";
import { CLEAR_EXPORT_LOGS_CSV, EXPORT_LOGS_CSV } from "../types";

export const {
  exportLogsCsv,
  exportLogsCsvPending,
  exportLogsCsvFulfilled,
  exportLogsCsvRejected,
} = createAsyncActions(EXPORT_LOGS_CSV, "exportLogsCsv");

export const clearExportLogsCsvResult = createAction(CLEAR_EXPORT_LOGS_CSV);



// WEBPACK FOOTER //
// ./src/features/log/actions/exportLogsCsvActions.js